export enum StreamType {
  CONVERSATION = 'conversation',
  ACTIVITY = 'activity',
  STATUS = 'status',
}

export function streamTypeToString(type: StreamType): string {
  switch (type) {
    case StreamType.CONVERSATION:
      return 'Conversation'
    case StreamType.ACTIVITY:
      return 'Activity'
    case StreamType.STATUS:
      return 'Status'
  }
}
